export default "__VITE_ASSET__BmJCoKsW__"